export default __webpack_public_path__ + "fb4e7e4f21e5642603061711861eff28.svg";